import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header-consulta',
  templateUrl: './header-consulta.component.html',
  styleUrls: ['./header-consulta.component.scss']
})
export class HeaderConsultaComponent implements OnInit {
  @Input() dadosConsulta: any;
  placaMercosul = false;
  qrcodeUrl = "";
  emplacamento = "";

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.url.pipe(first()).subscribe(r => this.qrcodeUrl = environment.homeUrl + '/consulta/' + r.join('/'))
    this.verificarMercosul(this.dadosConsulta.placaEntrada);
    this.setEmplacamento();
  }

  verificarMercosul(placa) {
    if (placa === null || placa === undefined ) {
      return;
    }

    placa = placa.replace(/[^0-9a-zA-Z]/, '');
    if (placa[4] == '0') {
      this.placaMercosul = false;
    }
    else {
      this.placaMercosul = !parseInt(placa[4], 10);
    }
  }

  setEmplacamento() {
    let emplacamento = 'UF - MUNICIPIO';
    let consultas = ['BIN_ESTADUAL', 'AGREGADOS', 'BIN_FEDERAL', 'BIN_FEDERAL_RF', 'BIN_RENAJUD', 'BIN_RF'];
    let dadosConsulta = this.dadosConsulta.consultas.find(c => c.codigoControle == 'OK' && consultas.find(c2 => c.tipoConsulta == c2));
    if (dadosConsulta) {
      let consulta = dadosConsulta.consulta;
      let uf = consulta.uf || consulta.ufMunicipio || 'UF';
      let municipio = consulta.municipio || 'MUNICIPIO';
      emplacamento = uf + ' - ' + municipio;
    }
    emplacamento !== 'UF - MUNICIPIO' ? this.emplacamento = emplacamento : this.emplacamento = null;
  }
}
